module.exports = __webpack_public_path__ + "img/process.dc41a899.png";